import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { BOSS_MODE_PATH, SELLER_PATH } from 'data/global';

const RedirectBossModeRouter: React.FC = () => {
  const { pathname } = useLocation();

  const path = pathname.replace(BOSS_MODE_PATH, SELLER_PATH);

  return <Navigate to={path} replace />;
};

export default RedirectBossModeRouter;
